import {
  Stack,
  Typography
} from '@mui/material';
import _ from 'lodash';
import { CustomIcon } from 'modules/components/layer00';
import { MilestoneDetailCardLayout } from 'modules/components/layer05';
import React, {
  ReactNode,
  useState
} from 'react';
import { theme } from 'theme';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { SaveMilestoneModal } from 'modules/components/layer17';
import { useAccessState } from 'modules/common';


type IFieldName = 'TITLE' | 'DURATION' | 'START' | 'END' | 'STATUS';

const fieldName: IFieldName[] = [
  'TITLE',
  'DURATION',
  'START',
  'END',
  'STATUS'
];

const __field2Icon: Record<IFieldName, ReactNode> = {
  TITLE: <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  DURATION: <CustomIcon.large.FC icon='CLOCK' stroke={theme.palette.primary.main} />,
  START: <CustomIcon.large.FC icon='PLAY' stroke={theme.palette.primary.main} />,
  END: <CustomIcon.medium.FC icon='FLAG1' stroke={theme.palette.primary.main} />,
  STATUS: <CustomIcon.large.FC icon='STAR' stroke={theme.palette.primary.main} />
};

export type MilestoneDetailCardProps = {

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MilestoneDetailCardProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.milestoneId ?? '');
  const access = useAccessState('Milestone');

  const [
    isVisible,
    setIsVisible
  ] = useState(false);


  return (
    <>
      {
        isVisible && (
          <SaveMilestoneModal.FC
            id={params.milestoneId ?? ''}
            handleClose={() => setIsVisible(() => false)}
            isVisible={isVisible}
          />
        )
      }
      <MilestoneDetailCardLayout.FC
        actionButton={{
          text: 'Edit Details',
          onClick: () => {
            setIsVisible(() => true);
          },
          disabled: !access.update
        }}
        title='General'
        subTitle='Basic information about finish, visible to owner'
      >
        <Stack
          rowGap='1rem'
          justifyContent='center'
        >
          {fieldName.map((node, i) => (
            <Stack
              key={i}
              columnGap='.5rem'
              alignItems='center'
              direction='row'
            >
              {__field2Icon[node]}
              <Typography
                variant='formLabel'
              >
                {_.upperFirst(_.lowerCase(node))}
              </Typography>

              <Typography
                variant='formInput'
              >
                {data[_.toLower(node)]}
              </Typography>
            </Stack>
          ))}

        </Stack>
      </MilestoneDetailCardLayout.FC>
    </>
  );
};
